import { regisConstants } from '../../constants'

// const user = JSON.parse(localStorage.getItem('user'))

const initialState = {
  inviteData: null,
  isJoin: false,
  checkedId: false,
  checkedGroupId: false,
  checkedRegistNo: false,
  isDuplBizNo: false,
  checkedJoinFlag: '',
  checkMobileYn: null,
  uthInfo: null,
  uthIsJoinYn: false,
}

export default function regis(state = initialState, action) {
  switch (action.type) {
    /********************
     이용자 초대코드로 정보 조회
     ********************/

    case regisConstants.GET_INVITE_REQUEST:
      return {
        ...state,
      }
    case regisConstants.GET_INVITE_SUCCESS:
      console.log('이용자 초대코드로 정보', action.response)
      return {
        ...state,
        inviteData: action.response,
      }
    case regisConstants.GET_INVITE_FAILURE:
      return {}
    /********************
       회원가입
       ********************/
    case regisConstants.REGISTER_MANAGER_REQUEST:
      return {
        ...state,
      }
    case regisConstants.REGISTER_MANAGER_SUCCESS:
      return {
        ...state,
        isJoin: true,
      }
    case regisConstants.REGISTER_MANAGER_FAILURE:
      return {
        ...state,
        isJoin: false,
      }
    case regisConstants.REGISTER_SIMPLE_MANAGER_REQUEST:
      return {
        ...state,
      }
    case regisConstants.REGISTER_SIMPLE_MANAGER_SUCCESS:
      return {
        ...state,
        isJoin: true,
      }
    case regisConstants.REGISTER_SIMPLE_MANAGER_FAILURE:
      return {
        ...state,
        isJoin: false,
      }

    case regisConstants.REGISTER_USER_REQUEST:
      return {
        ...state,
      }
    case regisConstants.REGISTER_USER_SUCCESS:
      return {
        ...state,
        isJoin: true,
      }
    case regisConstants.REGISTER_USER_FAILURE:
      return {
        ...state,
        isJoin: false,
      }
    case regisConstants.REGISTER_COMPLETE:
      return {
        ...state,
        isJoin: false,
        checkMobileYn: null, // 가입완료시 초기화
      }
    /********************
       관리자 아이디 중복체크
       ********************/
    // case regisConstants.CHECK_GROUP_REQUEST:
    //   return {
    //     ...state
    //   }
    // case regisConstants.CHECK_GROUP_SUCCESS:
    //   return {
    //     ...state,
    //     checkedGroupId: true,
    //   }
    // case regisConstants.CHECK_GROUP_FAILURE:
    //   return {
    //     ...state,
    //     isJoin: false,
    //   }
    // case regisConstants.CHECK_GROUP_RESET:
    //   return {
    //     ...state,
    //     checkedGroupId: false,
    //   }
    /********************
       사용자 아이디 중복체크
       ********************/
    case regisConstants.CHECK_ID_REQUEST:
      return {
        ...state,
      }
    case regisConstants.CHECK_ID_SUCCESS:
      return {
        ...state,
        checkedId: true,
      }
    case regisConstants.CHECK_ID_FAILURE:
      return {
        ...state,
        isJoin: false,
      }
    case regisConstants.CHECK_ID_RESET:
      return {
        ...state,
        checkedId: false,
      }
    case regisConstants.CHECK_RGSNO_RESET:
      return {
        ...state,
        checkedRegistNo: false,
      }
    case regisConstants.CHECKED_REGIST_NO:
      return {
        ...state,
        checkedRegistNo: action.checkedRegistNo,
      }

    /************************************************************
     * 사용자 MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크
     ************************************************************/
    case regisConstants.CHECK_MOBILE_REQUEST:
      return {
        ...state,
      }
    case regisConstants.CHECK_MOBILE_SUCCESS:
      return {
        ...state,
        checkMobileYn: action.response.data.payload,
      }
    case regisConstants.CHECK_MOBILE_FAILURE:
      return {
        ...state,
        checkMobileYn: false,
        isJoin: false,
      }

    /************************************************************
     * 사업자번호 중복체크
     ************************************************************/
    case regisConstants.DUPLE_BIZNO_REQUEST:
      return {
        ...state,
      }
    case regisConstants.DUPLE_BIZNO_SUCCESS:
      return {
        ...state,
        isDuplBizNo: action.response.data.payload,
      }
    case regisConstants.DUPLE_BIZNO_FAILURE:
      return {
        ...state,
        isJoin: false,
        isDuplBizNo:false,
      }

    /********************
       회원가입 구분
       ********************/
    case regisConstants.SET_JOIN_FLAG_USER:
      return {
        ...state,
        checkedJoinFlag: 'user',
      }

    case regisConstants.SET_JOIN_FLAG_CORP:
      return {
        ...state,
        checkedJoinFlag: 'corp',
      }

      /** 연계기업회원 **/
    case regisConstants.SET_JOIN_FLAG_LINK_CORP:
      return {
        ...state,
        checkedJoinFlag: 'link',
      }
    case regisConstants.SET_JOIN_FLAG_UTH:
      return {
        ...state,
        checkedJoinFlag: 'uth',
      }

    case regisConstants.CHECKED_JOIN_FLAG:
      return {
        ...state,
        checkedJoinFlag: state.checkedJoinFlag,
      }
    case regisConstants.UTH_INFO_SUCCESS:
      return {
        ...state,
        //        uthInfo: action.data?.payload,
        uthInfo: action.response,
        uthIsJoinYn: false,
      }
    case regisConstants.UTH_INFO_FAILURE:
      return {
        ...state,
        uthIsJoinYn: true,
      }
      
    case regisConstants.CHECK_CRTFCT_REQUEST:
      return {
        ...state,
      }
    case regisConstants.CHECK_CRTFCT_SUCCESS:
      return {
        ...state,
        crtfctInfos: action.response,
      }
    case regisConstants.CHECK_CRTFCT_FAILURE:
      return {
        ...state,
        isJoin: false,
      }
    default:
      return state
  }
}
